import * as yup from 'yup';

export const ImageDataValidation = yup.object().shape({
  action: yup.string().trim().when('url', { is: '', then: yup.string().trim().required('Image is required') }),
  url: yup.string().trim(),
  imageName: yup.string().trim(),
  base64Image: yup.string(),
  type: yup.string().trim(),
});

export const ContentImageDataValidation = yup.object().shape({
  url: yup.string().trim().required('Image is a required field'),
  contentUrl: yup.string().trim().label('Content url'),
});

export const ContentDataValidation = (
  fileSize:number,
  supportedFormate:string[],
) => (yup.object().shape({
  action: yup.string().trim().when('url', { is: '', then: yup.string().trim().required('File is required') }),
  url: yup.string().trim(),
  fileNames: yup.string().trim(),
  file: yup.mixed()
    .test('fileSize', 'File too large', (value) => value === null || (value && value.size <= fileSize))
    .test(
      'fileFormat',
      'Unsupported file type',
      (value) => value === null || (value && supportedFormate.includes(value.type)),
    ),
  type: yup.string().trim(),
  extension: yup.string().trim(),

}));
